import Reflux from 'reflux';

const AlarmCallbackHistoryActions = Reflux.createActions({
  list: { asyncResult: true },
});

export default AlarmCallbackHistoryActions;



// WEBPACK FOOTER //
// ../graylog2-server/graylog2-web-interface/src/actions/alarmcallbacks/AlarmCallbackHistoryActions.js